module.exports = __webpack_public_path__ + "media/icons/open-book-2a9bfa73.svg";